import { HistoryState, History, BatchHistory, ContinuousHistory } from './state'

export const getCheckItems = function (state: HistoryState): History[] {
  return state.item.check
}

export const getBatchItems = function (state: HistoryState): BatchHistory[] {
  return state.item.batch
}

export const getCckItems = function (state: HistoryState): ContinuousHistory[] {
  return state.item.cck
}

export const getCheckLoadStatus = function (state: HistoryState): boolean {
  return state.load.check
}

export const getBatchLoadStatus = function (state: HistoryState): boolean {
  return state.load.batch
}

export const getCckLoadStatus = function (state: HistoryState): boolean {
  return state.load.cck
}
